import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { withRadium, DetectCompact } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import gtmHandler from "AtomicUtils/gtmHandler"
import { H4, P, AlertIcon, Caption } from "AtomicComponents"
import buttonStyles from "AtomicComponents/Button/Button.less"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

const MyMazdaRecallNotification = props => (
  <div style={styles.wrapper(props.compact)}>
    <div style={{ marginRight: props.compact ? "0" : "16px" }}>
      <div style={{ display: "flex", flexDirection: props.compact ? "column" : "row", alignItems: props.compact ? "center" : "flex-start" }}>
        <AlertIcon style={styles.icon(props.compact)} />
        <H4 withDetails>
          Urgent recall(s) on your {props.namePlate} [{props.rego}]
        </H4>
      </div>
      <div>
        <P>
          <Link
            to={props.recallDetailPageUrl}
            className={classnames({
              [typographyStyles.blackColor]: true
            })}>
            View recall details
          </Link>
          {" or request a service with your Service Dealer immediately."}
        </P>
        <Caption>{props.timestamp}</Caption>
      </div>
    </div>
    <div
      style={{
        flex: "1 1 auto",
        alignSelf: "center",
        textAlign: props.compact ? "center" : "right"
      }}>
      <Link to={props.requestServicePageUrl} style={{ textDecoration: "none" }}>
        <span
          className={`Button ${classnames({
            [buttonStyles.Button]: true,
            [buttonStyles.ButtonFullWidth]: true,
            [buttonStyles.ButtonRed]: true
          })}`}
          onClick={() => {
            gtmHandler({
              pageCategory: "MyMazda - Dashboard",
              pageAction: `"RECALL BLOCK" - clicked "${props.buttonLinkText.toUpperCase()}"`
            })
          }}
        >{props.buttonLinkText}</span>
      </Link>
    </div>
  </div>
)

const styles = {
  wrapper: compact => ({
    display: "flex",
    justifyContent: "space-between",
    flexWrap: compact ? "wrap" : "nowrap",
    margin: "5em 1em 0",
    padding: "2em",
    border: `1px solid ${COLOR_PALETTE.GRAY}`,
    background: COLOR_PALETTE.WHITE,
    textAlign: compact ? "center" : "left"
  }),
  heading: compact => ({
    color: COLOR_PALETTE.BLACK,
    position: "relative",
    paddingLeft: compact ? "0" : "2em",
    textAlign: compact ? "center" : "left"
  }),
  icon: compact => ({
    width: compact ? "20px" : "22px",
    height: compact ? "28px" : "28px",
    margin: compact ? "0 0 16px 0" : "0 16px 0 0"
  })
}

MyMazdaRecallNotification.propTypes = {
  compact: PropTypes.bool,
  namePlate: PropTypes.string,
  rego: PropTypes.string,
  requestServicePageUrl: PropTypes.string,
  buttonLinkText: PropTypes.string,
  recallDetailPageUrl: PropTypes.string,
  timestamp: PropTypes.string
}

export default withRadium(DetectCompact())(MyMazdaRecallNotification)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/recall-notification/index.jsx